import base from './routes/base.js';
import face from './routes/face.js';
import h5 from './routes/h5.js';
import share from './routes/share.js';
import deregister from './routes/deregister.js'

let routes = [
  {
    path: '/',
    redirect: 'login',
  },
];

export default new VueRouter({
  routes: [...routes, ...base, ...face, ...h5, ...share,...deregister],
});
